(function (window, document) {
  'use strict';

  var COMPONENT = 'smart_banner';

  var EVENT_IDS = {
    IMPRESSION: 'allos_smartbanner_impression',
    CLICK_CLOSE: 'allos_smartbanner_click_close',
    CLICK_OPEN: 'allos_smartbanner_click_open',
  };

  var OPEN_DEBOUNCE_MS = 400;
  var LUM_TRACK_POLL_MS = 150;
  /** Max time to wait for `lum_track` after a qualifying banner is seen */
  var LUM_TRACK_WAIT_MS = 90000;
  /** How long the DOM observer stays active if impression not yet sent */
  var BANNER_OBSERVER_MS = 60000;

  var gaImpressionEmitted = false;
  var lumImpressionEmitted = false;
  var lastOpenTrackedAt = 0;
  var observer = null;
  var observerTimer = null;
  var lumTrackPollInterval = null;
  var lumTrackPollDeadline = 0;

  function isLumTrackReady() {
    return typeof window.lum_track === 'function';
  }

  function safeLumTrack(eventId, data) {
    if (!isLumTrackReady()) {
      return;
    }
    try {
      window.lum_track('event', eventId, data);
    } catch (e) {
      /* SBEVT-07: fail silently */
    }
  }

  function safeDataLayerCall(fn) {
    if (typeof fn !== 'function') {
      return;
    }
    try {
      fn();
    } catch (e) {
      /* GA helpers must not break banner UX */
    }
  }

  function buildPayload(platform) {
    return {
      platform: platform,
      component: COMPONENT,
    };
  }

  function platformFromBannerRoot(element) {
    if (!element || !element.classList) {
      return null;
    }
    if (element.classList.contains('smartbanner--ios')) {
      return 'ios';
    }
    if (element.classList.contains('smartbanner--android')) {
      return 'android';
    }
    return null;
  }

  function findBannerRoot() {
    var nodes = document.querySelectorAll('.smartbanner');
    var i;
    var platform;
    for (i = 0; i < nodes.length; i++) {
      platform = platformFromBannerRoot(nodes[i]);
      if (platform) {
        return nodes[i];
      }
    }
    return null;
  }

  function stopLumTrackPoll() {
    if (lumTrackPollInterval !== null) {
      window.clearInterval(lumTrackPollInterval);
      lumTrackPollInterval = null;
    }
    lumTrackPollDeadline = 0;
  }

  function stopBannerObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (observerTimer !== null) {
      window.clearTimeout(observerTimer);
      observerTimer = null;
    }
  }

  function emitGaImpressionOnce() {
    if (gaImpressionEmitted) {
      return;
    }
    gaImpressionEmitted = true;
    safeDataLayerCall(window.dataLayerSmartBannerImpression);
  }

  /**
   * Emit impressions when the banner qualifies.
   * GA fires as soon as the banner is present; lum_track waits until ready.
   */
  function tryEmitImpression() {
    var root = findBannerRoot();
    if (!root) {
      stopLumTrackPoll();
      return;
    }

    var platform = platformFromBannerRoot(root);
    if (!platform) {
      return;
    }

    emitGaImpressionOnce();
    /* Banner is qualified — DOM watch no longer needed for either stack */
    stopBannerObserver();

    if (lumImpressionEmitted) {
      return;
    }

    if (!isLumTrackReady()) {
      if (lumTrackPollInterval === null) {
        lumTrackPollDeadline = Date.now() + LUM_TRACK_WAIT_MS;
        lumTrackPollInterval = window.setInterval(function () {
          if (Date.now() > lumTrackPollDeadline) {
            stopLumTrackPoll();
            return;
          }
          tryEmitImpression();
        }, LUM_TRACK_POLL_MS);
      }
      return;
    }

    stopLumTrackPoll();
    lumImpressionEmitted = true;
    safeLumTrack(EVENT_IDS.IMPRESSION, buildPayload(platform));
  }

  function startBannerWatch() {
    tryEmitImpression();
    if (gaImpressionEmitted) {
      return;
    }

    if (typeof MutationObserver === 'undefined') {
      return;
    }

    observer = new MutationObserver(function () {
      tryEmitImpression();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    observerTimer = window.setTimeout(function () {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      observerTimer = null;
    }, BANNER_OBSERVER_MS);
  }

  function payloadForBannerInteraction(target) {
    var root = target && target.closest ? target.closest('.smartbanner') : null;
    if (!root) {
      return null;
    }
    var platform = platformFromBannerRoot(root);
    if (!platform) {
      return null;
    }
    return buildPayload(platform);
  }

  function onDocumentClick(event) {
    var t = event.target;
    if (!t || !t.closest) {
      return;
    }

    if (t.closest('.smartbanner__exit')) {
      var closePayload = payloadForBannerInteraction(t.closest('.smartbanner__exit'));
      if (closePayload) {
        safeDataLayerCall(window.dataLayerSmartBannerFechar);
        safeLumTrack(EVENT_IDS.CLICK_CLOSE, closePayload);
      }
      return;
    }

    if (t.closest('.smartbanner__button')) {
      var now = Date.now();
      if (now - lastOpenTrackedAt < OPEN_DEBOUNCE_MS) {
        return;
      }
      var openPayload = payloadForBannerInteraction(t.closest('.smartbanner__button'));
      if (openPayload) {
        lastOpenTrackedAt = now;
        safeDataLayerCall(window.dataLayerSmartBannerAbrir);
        safeLumTrack(EVENT_IDS.CLICK_OPEN, openPayload);
      }
    }
  }

  function bootstrap() {
    startBannerWatch();
    document.addEventListener('click', onDocumentClick, false);
    window.addEventListener('load', tryEmitImpression, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})(window, document);
